import { PropsWithChildren } from "react";

import { Box, useMediaQuery, useTheme } from "@chakra-ui/react";

import SidebarDrawer from "@/components/shared/SidebarDrawer";
import { NAV_MENU_WIDTH } from "@/constants/sizes";
import { useLeftDrawer } from "@/providers/useDrawers";

function MenuSidebar({ children }: PropsWithChildren) {
  const theme = useTheme();
  const [isLargerThanXl] = useMediaQuery(`(min-width: ${theme.breakpoints.xl})`, {
    ssr: false,
  });
  const { isOpen, onClose, onOpen, highlightBlockId, setHighlightBlockId } = useLeftDrawer();

  if (!isLargerThanXl) {
    return (
      <SidebarDrawer
        {...{ isOpen, onClose, onOpen, highlightBlockId, setHighlightBlockId }}
        maxW={NAV_MENU_WIDTH}
        overflowX="hidden"
      >
        {children}
      </SidebarDrawer>
    );
  }
  return (
    <Box h="full" zIndex={2}>
      {children}
    </Box>
  );
}

export default MenuSidebar;
